"use client"
import React from 'react'
import JobCard from '../../components/JobCard/JobCard';
import { motion } from 'framer-motion';

function Careers({ blok }) {
    return (
        <div className='pb-20 bg-asmPageTopBG bg-repeat-space bg-cover w-full'>
            <div className='' style={{
                backgroundSize: "cover", // Ensure the image covers the entire section
                backgroundRepeat: "repeat", // Prevent repeating the background
                // maxWidth: 1920,
                // margin: 'auto'
            }}>
                <div className="font-aileron py-20 lg:pt-32 text-center font-bold">
                    <h2 className="bg-custom-radial bg-clip-text text-transparent text-[48px] lg:text-[80px]">
                        {blok.title}
                    </h2>
                    <div className="font-lato mt-4 text-[20px] w-[80%] lg:w-[60%] m-auto lg:text-[32px] font-normal ">
                        {blok.subtitle}
                    </div>
                </div>
            </div>
            <div className='' style={{
                backgroundSize: "cover", // Ensure the image covers the entire section
                backgroundRepeat: "repeat", // Prevent repeating the background
                // maxWidth: 1920,
                // margin: 'auto'
            }}>
                <div className='flex justify-center'>
                    <div className='space-y-10 lg:w-[1200px] lg:[330px] p-10'>
                        {blok.jobs.map((job, index) => (
                            <motion.div
                                key={`job-${index}`}
                                initial={{ opacity: 0, x: index % 2 === 0 ? -100 : 100 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.8, delay: index * 0.2 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                <JobCard
                                    jobname={job.title}
                                    location={job.job_location}
                                    jobType={job.job_type}
                                    jobLevel={job.experience}
                                    jobDescription={job.description}
                                    url={job.url}
                                />
                            </motion.div>
                        ))}
                    </div>
                </div>
                <div className='flex flex-col items-center mt-20'>
                <h5 className="font-aileron font-bold bg-custom-radial bg-clip-text text-transparent text-[28px] lg:text-[48px] lg:mb-2 text-center lg:text-start">
                    {blok?.BenefitTitle}
                </h5>

                {blok?.Benefits?.map((benefit, index) => {
                    if (index % 2 == 0) {
                        return <div key={`Benefit-${index}`} className="lg:flex  items-center justify-center lg:gap-[50px] lg:w-[1202px] mx-auto z-20 lg:mb-10 bg-white lg:h-[398px] shadow-lg rounded-[40px] lg:mt-16 p-6  py-10 lg:p-0 m-10 lg:m-auto">
                            {/* Left Column (Main Image) */}
                            <div className="lg:flex-1 mt-6 lg:ml-10">
                                <h5 className="font-aileron font-bold bg-custom-radial bg-clip-text text-transparent text-[28px] lg:text-[48px] lg:mb-2 text-center lg:text-start">
                                    {benefit.title}
                                </h5>
                                {/* Description */}
                                <p className="font-lato text-[16px] lg:text-[18px] lg:mb-6 lg:w-[85%] mb-6 m-auto text-center lg:text-start lg:m-0" >
                                    {benefit.description}
                                </p>
                            </div>
                            <div className="w-full max-w-md">
                                <div className="lg:-mt-10 lg:w-[463px] lg:h-[455px] w-[290px] lg:flex justify-center items-center m-auto mb-10 lg:mb-0 lg:-ml-20">
                                    <img
                                        initial={{ opacity: 0, x: 100 }}
                                        transition={{ duration: 0.5, delay: 0.2 }}
                                        src={benefit.image?.filename} />
                                </div>
                            </div>
                        </div>
                    }
                    return <div className="lg:flex justify-center items-center  lg:gap-[50px] lg:w-[1202px] mx-auto z-20 lg:mb-10 bg-white lg:h-[444px] rounded-[40px] lg:mt-16 p-6  py-10 lg:p-0 m-10 lg:m-auto shadow-lg">
                        {/* Left Column (Main Image) */}
                        <div className="w-full max-w-md">
                            <div
                                initial={{ opacity: 0, x: -100 }}
                                transition={{ duration: 0.5, delay: 0.2 }}
                                className="lg:-mt-0 lg:w-[463px] lg:h-[455px] w-[290px] lg:flex justify-center items-center m-auto mb-10 lg:mb-0">
                                <img src={benefit.image?.filename} />
                            </div>
                        </div>

                        <div className="lg:flex-1 flex flex-col justify-center">
                            <h5 className="font-aileron font-bold bg-custom-radial bg-clip-text text-transparent text-[28px] lg:text-[48px] lg:mb-6 text-center lg:text-start">
                                {benefit.title}
                            </h5>
                            {/* Description */}
                            <p className="font-lato text-[16px] lg:text-[18px] lg:mb-6 lg:w-[90%] mb-6 m-auto text-center lg:text-start lg:m-0">
                                {benefit.description}
                            </p>
                        </div>
                    </div>
                })}
            </div>
            </div>
            {/* <Footer blok={blok} /> */}
        </div>
    )
}

export default Careers